export const baseUrl = "https://api.nanopulse.in/api/";